/* File: frontend/src/components/reputation/AssetHistoryList.js */
/* Component for Asset History List */
/* Version: v1.0 (Initial Extract from v10.18) */
/* Date: 2025-12-15 18:45 EST */
/* Description: 
   - Вынесен список "Active Assets" в отдельный компонент.
   - Реализован скролл (max-height: 450px).
   - Дизайн карточек соответствует макету Photoshop (Single Row Layout).
   - Содержит кнопки: Preview, Post, Copy.
*/

import React from 'react';
import { Zap, Code, Copy, Eye, Send, FileText as FileIcon } from 'lucide-react';

const styles = {
    scrollContainer: {
        maxHeight: '450px',
        overflowY: 'auto',
        border: '1px solid #d1fae5',
        borderRadius: '0.5rem',
        backgroundColor: '#f0fdf4',
        padding: '15px',
        marginTop: '10px'
    },
    assetCard: {
        backgroundColor: 'white',
        border: '2px solid #bbf7d0',
        borderRadius: '8px',
        marginBottom: '12px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '15px 20px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.02)',
        width: '100%'
    },
    assetLeftSection: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '4px'
    },
    assetRightSection: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    btnBase: {
        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px',
        padding: '8px 14px', borderRadius: '6px', fontSize: '0.75rem', fontWeight: '600',
        cursor: 'pointer', transition: 'all 0.2s', border: '1px solid', textTransform: 'uppercase',
        minWidth: '100px'
    },
    btnPreview: { backgroundColor: 'white', borderColor: '#10b981', color: '#059669' },
    btnPost: { backgroundColor: '#22c55e', borderColor: '#22c55e', color: 'white' },
    btnCopy: { backgroundColor: 'white', borderColor: '#94a3b8', color: '#475569' }
};

const AssetHistoryList = ({ assets, onPreview, onPost, onCopy }) => {
    if (!assets || assets.length === 0) {
        return (
            <div style={{ padding: '30px', textAlign: 'center', color: '#94a3b8', fontSize: '12px', fontStyle: 'italic' }}>
                No active assets generated. Start a Content Warfare operation above.
            </div>
        );
    }

    return (
        <div className="ui-scroll" style={{ maxHeight: '300px', overflowY: 'auto', borderTop: '1px solid #f1f5f9' }}>
            {assets.map((fix) => (
                <div key={fix.id} style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    padding: '8px 12px', borderBottom: '1px solid #f8fafc', fontSize: '12px',
                    transition: 'background 0.2s'
                }}
                    onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
                    onMouseLeave={e => e.currentTarget.style.background = 'white'}
                >
                    {/* LEFT: ICON + TYPE */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '0' }}>
                        <div style={{
                            width: '24px', height: '24px', borderRadius: '4px',
                            background: fix.fix_type === 'article_seo' ? '#fef3c7' : '#dbeafe',
                            color: fix.fix_type === 'article_seo' ? '#b45309' : '#1e40af',
                            display: 'flex', alignItems: 'center', justifyContent: 'center'
                        }}>
                            {fix.fix_type === 'article_seo' ? <Zap size={14} /> : <Code size={14} />}
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <span style={{ fontWeight: '600', color: '#334155' }}>
                                {fix.fix_type === 'article_seo' ? 'Cornerstone Article' : 'Schema JSON-LD'}
                            </span>
                            <span style={{ fontSize: '10px', color: '#94a3b8' }}>
                                {new Date(fix.created_at).toLocaleDateString()}
                            </span>
                        </div>
                    </div>

                    {/* RIGHT: ACTIONS */}
                    <div style={{ display: 'flex', gap: '6px' }}>
                        <button onClick={() => onPreview(fix.generated_code)} style={{ padding: '4px', color: '#64748b', cursor: 'pointer', border: 'none', background: 'transparent' }} title="Preview">
                            <Eye size={14} />
                        </button>
                        <button onClick={() => onCopy(fix.generated_code)} style={{ padding: '4px', color: '#64748b', cursor: 'pointer', border: 'none', background: 'transparent' }} title="Copy">
                            <Copy size={14} />
                        </button>
                        {fix.fix_type === 'article_seo' && (
                            <button onClick={() => onPost(fix)} style={{
                                padding: '4px 8px', background: '#22c55e', color: 'white', border: 'none', borderRadius: '4px',
                                fontSize: '10px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px'
                            }}>
                                <Send size={10} /> POST
                            </button>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default AssetHistoryList;